import { render } from "./Dashboard.vue?vue&type=template&id=0d9c58cd&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=0d9c58cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d9c58cd"]])

export default __exports__